<template>
  <div class="support li_none_style">
    <banner :bannerObj="banner"/>
      <div class="container">
        <div class="content">
          <headline
            :titleObj="support_title"
          ></headline>

          <ul class='flex-container'>
            <div
              class="support-container"
              v-for="(item, index) in supportItem"
              :key="index"
            >
              <div
                class="support-box-container"
              >
                <div class="support-img">
                  <img :src="item.img">
                </div>
                <div class="support-box ">
                  <div>
                    <div class="support-title">
                      {{ item.title }}
                    </div>
                    <div class="support-content">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <div class="technology content">
          <headline
            :titleObj="technology_title"
          ></headline>

          <div v-if="bigScreen">
            <img class="technology-background technology-background-frontend" src="../assets/images/frontend.png"/>
            <img class="technology-background technology-background-backend" src="../assets/images/backend.png"/>

            <div class="technology-content">
              <div class="screen-container">
                <transition-group name="fade" tag="span">
                  <div v-for="number in [technologyItems.client_img_count]" v-bind:key="number">
                    <div class="client-part">
                      <img :src="technologyItems.client_img[technologyItems.client_img_count]"/>
                    </div>
                  </div>
                </transition-group>
                <img class="screen" src="../assets/images/screen-img.png"/>
              </div>

              <div class="img-slider">
                <div
                  v-for="slide in server_slides"
                  :key="slide.id"
                  class="server-slide"
                  @animationend.self="removeServerSlide(slide.id)"
                >
                  <div class="server-part">
                    <div class="small_ball small_ball-one"></div>
                    <div class="small_ball small_ball-two"></div>
                    <img :src="technologyItems.server_img[slide.imageIndex]"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="technology-mobile_title">前端技術</div>
            <div class="technology-mobile">
              <div class="technology-mobile_article">
                <!--<hr>-->
                <div class="technology-mobile-img">
                  <li v-for="img in technologyItems.client_img" :key="img">
                    <img :src="img"/>
                  </li>
                </div>
              </div>
            </div>
            <div class="technology-mobile_title">後端技術</div>
            <div class="technology-mobile">
              <div class="technology-mobile_article">
                <!--<hr>-->
                <div class="technology-mobile-img">
                  <li v-for="img in technologyItems.server_img" :key="img">
                    <img :src="img"/>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import Banner from '@/components/Banner.vue'
  import Headline from '@/components/Headline.vue'

  export default {
      components: {
          'banner': Banner,
          'headline': Headline
      },
      name: 'Support',
      data() {
          return {
              server_animate_interval: null,
              server_slide_id: 0,
              server_slides: [],
              client_animate_interval: null,
              resize_handler: null,
              bigScreen: true,
              windowWidth: 0,
              technologyItems: {
                  server_img_count: 0,
                  server_img: [
                      new URL('../assets/images/2x/python_logo@2x.png', import.meta.url).href,
                      new URL('../assets/images/2x/django_logo@2x.png', import.meta.url).href,
                      new URL('../assets/images/2x/grid-data@2x.png', import.meta.url).href,
                      new URL('../assets/images/2x/scipy@2x.png', import.meta.url).href,
                      new URL('../assets/images/2x/geographic-data@2x.png', import.meta.url).href,
                  ],
                  client_img_count: 0,
                  client_img: [
                      new URL('../assets/images/2x/vue_logo@2x.png', import.meta.url).href,
                      new URL('../assets/images/2x/leaflet_logo@2x.png', import.meta.url).href,
                      new URL('../assets/images/2x/HTML_logo@2x.png', import.meta.url).href,
                      new URL('../assets/images/2x/webpack_logo@2x.png', import.meta.url).href,
                      new URL('../assets/images/2x/webmap@2x.png', import.meta.url).href,
                      new URL('../assets/images/2x/data-visualization@2x.png', import.meta.url).href,
                  ],
              },
              supportItem: [{
                  'title': '客製化天氣防災資訊處理與整合',
                  'content': '將全台龐大的氣象、防災資訊，彙整處理成專屬於您所需的資料，使複雜無序的大量數據能夠清楚顯示、並隨時提供最新的即時資訊，給所需要的人。',
                  'img': new URL('../assets/images/2x/customized-gy-or@2x.png', import.meta.url).href
              },{
                  'title': '高親互動式網頁應用設計規劃',
                  'content': '專業的UX(使用者經驗)及UI(使用者介面)設計與規劃，提供您良好的視覺觀感及高品質的操作體驗。',
                  'img': new URL('../assets/images/2x/UIUX-gy-or@2x.png', import.meta.url).href
              },{
                  'title': '輕量級地圖整合服務開發建置',
                  'content': '我們開發製作專屬於您的地圖，只保留所需的資訊、避免多餘的功能與負擔，並方便使用者快速得知所需訊息。不用遷就 Google 地圖，也不用購買龐大昂貴的 GIS，在這裡可以為您客製化成獨一無二的地圖資訊整合應用服務。',
                  'img': new URL('../assets/images/2x/lightmap-gy-or@2x.png', import.meta.url).href
              },{
                  'title': '敏捷開發團隊',
                  'content': '需求老是變來變去很討厭嗎? 然而需求變來變去才是資訊業唯一不變的真理!! 我們擁抱需求變動，運用敏捷式開發方法，有效率地開發、解決問題，以良好的互動及設計方法，使產品能夠更快速交付並彈性修改。',
                  'img': new URL('../assets/images/2x/agile-gy-or@2x.png', import.meta.url).href
              },{
                  'title': '跨平台適用',
                  'content': '支援Windows、IOS、Linux等系統，既使不是使用同一個環境，也能順利瀏覽網頁．',
                  'img': new URL('../assets/images/2x/digital-platform-gy-or@2x.png', import.meta.url).href
              }],
              support_title: {en: 'SUPPORTS', ch: '服務項目'},
              technology_title: {en: 'TECHNOLOGY', ch: '技術能力'},
              banner: {
                  title: '服務與技術',
                  info: '我們擅長敏捷式的開發流程，以緊密的互動式溝通，<br/>持續不斷協調創新，創造真正實用、好用之資訊應用服務',
                  img: new URL('../assets/images/2x/supports@2x.png', import.meta.url).href
              }
          }
      },
      beforeMount() {
          this.screen_sencor()
      },
      mounted() {
          this.server_slide()
          this.startTimer()
          window.addEventListener('focus', this.startTimer)
          window.addEventListener('blur', this.stopTimer)

          this.client_animate_interval = setInterval(() => {
              let count = this.technologyItems.client_img_count

              if (count+1 == this.technologyItems.client_img.length) {
                  this.technologyItems.client_img_count = 0
              }
              else {
                  this.technologyItems.client_img_count++
              }
          }, 3000);

          this.resize_handler = this.screen_sencor
          window.addEventListener('resize', this.resize_handler)
      },

      beforeUnmount() {
          this.stopTimer()
          window.clearInterval(this.client_animate_interval)
          window.removeEventListener('focus', this.startTimer)
          window.removeEventListener('blur', this.stopTimer)
          window.removeEventListener('resize', this.resize_handler)
      },

      methods: {

          startTimer() {
              if (this.server_animate_interval === null) {
                  this.server_animate_interval = setInterval(this.server_slide, 2000)
              }
          },

          stopTimer() {
              window.clearInterval(this.server_animate_interval)
              this.server_animate_interval = null
          },

          screen_sencor() {
              if (window.innerWidth > 768) {
                  this.bigScreen = true;
              }
              else {
                  this.bigScreen = false;
              }
          },

          server_slide() {
              const imageIndex = this.technologyItems.server_img_count

              this.server_slides.push({
                  id: this.server_slide_id++,
                  imageIndex
              })

              if (imageIndex + 1 === this.technologyItems.server_img.length) {
                  this.technologyItems.server_img_count = 0
              }
              else {
                  this.technologyItems.server_img_count++
              }
          },

          removeServerSlide(id) {
              this.server_slides = this.server_slides.filter((slide) => slide.id !== id)
          }
      }
  }
</script>
